import styled from "styled-components";
import Typography from "../../../designComponents/Typography";
import Button from "../../../designComponents/Button";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 25px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #f1effb;
  gap: 20px;
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  font-family: Arial, sans-serif;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 20px;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Typography)`
  font-size: 20px;
  font-weight: 600;
  color: #242b50;
`;

export const Navigation = styled.div`
  display: flex;
`;

export const NavLink = styled.div`
  cursor: pointer;
`;

export const NavText = styled(Typography)`
  color: #7e7e7e;
`;

export const ActiveNavText = styled(Typography)`
  color: #806ed8;
`;

export const ButtonsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 40px;
`;

export const RejectButton = styled(Button)`
  color: #7e7e7e;
  background-color: white;
  border: 1px solid #d8d8d8;
`;

export const AcceptButton = styled(Button)`
  color: white;
  background-color: #0a56af;
`;
export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 40px;
`;

export const LeftColumn = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  gap: 20px;
  width: 98%;
`;

export const RightColumn = styled.div``;

export const StyledCard = styled(Card)`
  margin-bottom: 20px;
`;

export const SectionTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
  color: #242b50;
`;

export const PropertyDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const LabelText = styled(Typography)`
  font-size: 0.9rem;
  font-weight: 600;
  color: #858585;
`;

export const ValueText = styled(Typography)`
  font-size: 0.9rem;
  font-weight: normal;
  color: #2c2c2c;
`;

export const ActivityContainer = styled.div`
  width: 300px;
  padding: 16px;
  border-radius: 8px;
`;

export const Notification = styled.div`
  padding: 8px 8px 8px 32px;
  border-left: 1px dotted #e3dff6;
  position: relative;
`;

export const NotificationContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
`;

export const ShowAllLink = styled(Typography)`
  color: #806ed8;
  cursor: pointer;
  text-decoration: underline;
  text-align: right;
  margin-top: 10px;
`;
